import type * as Types from '@/containers/Auth/Bind/types'
import API from '@/services/http'
import { bindUrl } from '@/services/url'
import type { AddressInfoType } from '@/store/addressSlice/types'

export interface ICheckBindParams {
  appId: string
  storeWebSite?: string
  storeId?: string
  extra?: {
    ticket?: string
  }
}
/**
 * 检查店铺绑定情况
 * @param params
 * @returns
 */
export const preCheckBindStore = (params: ICheckBindParams) => API.admin.post<Types.ResponseQueryBindType>(bindUrl.checkBind, params)

export interface IWooCommerceConfig {
  appName: string
  userId: string
  userHash: string
  scope: string
  returnUrl: string
  authCallBackUrl: string
}

/**
 * 查询 wooCommerceConfig
 * @returns
 */
export const getWooCommerceConfig = () => API.admin.post<IWooCommerceConfig>('/api/woocommerce/get_config')

export interface ExpressTypeSettingVo {
  /**服务偏好配置ID */
  id?: number
  /**店铺Seq（约束：userStoreSeq must less than 32!；userStoreSeq must not be blank） */
  userStoreSeq: string
  /**服务产品编码（约束：expressTypeCode must less than 64!；expressTypeCode must not be blank） */
  expressTypeCode: string
  /**配送方式
1：宅配；4：店配（约束：deliveryType must be greater than or equal to 1；deliveryType must be less than or equal to 4；deliveryType must not be null） */
  deliveryType: 1 | 2 | 3 | 4
  /**订单COD设置
example:["COD","NON_COD"]（约束：paymentTypes must not be empty） */
  paymentTypes: string[]
  /**收货地区代码
example:["MY","HK"]（约束：consigneeCountryCodes must not be empty） */
  consigneeCountryCodes: string[]
  /**服务商编码 */
  companyCode?: string
  /**服务商名称 */
  companyName?: string
  /**服务产品名称 */
  expressTypeName?: string
  /**服务产品配置扩展信息
比如pandago服务产品的默认门店信息 */
  settingExtraInfo?: ExpTypeSettingExtraInfo
}
export interface StoreDetailRes {
  defaultAddressNo: string
  address: AddressInfoType
  storeAlias: string
  authStatus: string
  storeId: string
  pullStatus: number
  logoUrl: string
  paymentType: 0 | 1 | 2 | 3 | 4
  extMap: Record<string, any>
  storeWebsite: string
  appId: string
  userStoreSeq: string
  storeName: string
  defaultLanguageCode: string
  expressTypeSettings: ExpressTypeSettingVo[]
  email: string
  status: string
  /** 拉单状态列表 */
  pullOrderStatus: string[]
  /** 归档状态列表 */
  archiveOrderStatus: string[]
}
export interface StoreDetailParams {
  getExpressTypeSettings: boolean
  getAddressDetail: boolean
  userStoreSeq: string
}

/** 获取全部店铺设置 */
export const getStoreDetail = (data: StoreDetailParams) => API.toast.post<StoreDetailRes>('/api/store/get', data)

export type SettingsParams = Pick<StoreDetailRes, 'userStoreSeq' | 'storeAlias' | 'defaultAddressNo' | 'paymentType' | 'expressTypeSettings'>

interface ExpTypeSettingExtraInfo {
  /**子账号编码 */
  subAccountSeq?: string
  /**pandago地址编码 */
  clientAddressNo?: string
  /**pandago地址是否有效*/
  valid?: boolean
}

interface CallBackConfigDetailVo {
  /**状态 */
  orderStatus?: string
  /**开关配置，true为开，false为关 */
  configSwitch?: boolean
  /**邮件通知配置，true为开，false为关（configSwitch=true时生效） */
  emailSwitch?: boolean
}
interface CallBackConfigVo {
  /**确认状态同步配置 */
  confirmed?: CallBackConfigDetailVo
  /**已完成状态同步配置 */
  completed?: CallBackConfigDetailVo
}

interface StoreSettingSaveRequest {
  /**应用ID */
  appId?: string
  /**店铺Seq（约束：userStoreSeq must less than 32!；userStoreSeq must not be blank） */
  userStoreSeq: string
  /**店铺别名（约束：storeAlias must less than 255!） */
  storeAlias?: string
  /**默认发货地址编码 */
  defaultAddressNo?: string
  /**0：默认配置；1：COD；2：NON_COD；3：WOOCOMMERCE；4：SHOPLINECROSSBORDER（约束：paymentType must be greater than or equal to 0；paymentType must be less than or equal to 4） */
  paymentType?: number
  /**是否对存量数据进行填数 */
  updateOrders?: boolean
  /**服务偏好设置 */
  expressTypeSettings?: ExpressTypeSettingVo[]
  /**拉单状态列表 */
  pullOrderStatus?: string[]
  /**归档状态列表 */
  archiveOrderStatus?: string[]
  /**店铺订单状态同步配置 */
  callBackConfig?: CallBackConfigVo
}
/** 保存店铺设置 */
export const saveStoreSettings = (data: StoreSettingSaveRequest) =>
  API.toast.post<{
    bindState: string
    isSuccess: boolean
  }>('/api/store/settings/save', data)
